Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the criteria step
	 */
	criteriaSetup() {
		const scope = this;

		scope.maxTags = Math.max($.app.post.$get('data.tags', []).length, 20);

		scope.initTypes();
		scope.initTags();
	},

	/**
	 * Initialize criteria step
	 */
	criteriaInit() {
		this.populateCriteria();
	},

	/**
	 * Initialize types
	 */
	initTypes() {
		const scope = this;

		$$('postType').on('click', (e, el) => {
			const type = el.dataset.value;
			const key = 'data.types';

			$.app.post.$get(key).includes(type) ?
				$.app.post.$drop(key, type) :
				$.app.post.$push(key, type);

			scope.populateCriteria();
		}, {
			namespace: 'post'
		});
	},

	/**
	 * Initialize tags
	 */
	initTags() {
		const scope = this;

		$.events.on({
			'input': {
				change: (e, el) => {
					const tag = el.value;
					const key = 'data.tags';

					if ($.app.post.$get(key).includes(tag)) {
						$.app.post.$drop(key, tag);
					} else {
						$.app.post.$push(key, tag);

						if (tag === 'cattle-ranch' && ! $.app.post.$has(key, 'ranch')) {
							$.app.post.$push(key, 'ranch');
						} else if ([
							'beachfront',
							'lakefront',
							'riverfront'
						].includes(tag) && ! $.app.post.$has(key, 'waterfront')) {
							$.app.post.$push(key, 'waterfront');
						} else if ([
							'a-frame-house',
							'barndominium',
							'cabin',
							'cottage',
							'farm-house',
							'homestead',
							'lodge',
							'mobile-home',
							'tiny-home'
						].includes(tag) && ! $.app.post.$has(key, 'house')) {
							$.app.post.$push(key, 'house');
						}
					}
				},
				click: (e, el) => {
					if (el.checked && ! (scope.maxTags - $.app.post.$get('data.tags', []).length)) {
						e.preventDefault();

						LS.util.warn('Only ' + scope.maxTags + ' tag selections allowed');
					}
				}
			},
			'$postTagsToggle': {
				mousedown: (e, el) => {
					$(el).toggleClass('-is-active');
				}
			}
		}, {
			delegate: '$postTags',
			namespace: 'post'
		});
	},

	/**
	 * Populate criteria
	 */
	populateCriteria() {
		const data = $.app.post.$get('data');
		const key = 'data.tags';
		const criteria = $.copy(LS.criteria);

		delete criteria.Attributes['by-owner'];
		delete criteria.Attributes['owner-financing'];

		for (const [key, options] of Object.entries(criteria)) {
			const tags = {};

			for (const slug of Object.keys(options)) {
				let disabled;

				if (! $.app.post.$has(key, slug)) {
					if ([
						'a-frame-house',
						'barndominium',
						'cabin',
						'cottage',
						'farm-house',
						'historic',
						'homestead',
						'house',
						'lodge',
						'mobile-home',
						'new-construction',
						'sustainable',
						'tiny-home'
					].includes(slug) && ! data.structure) {
						disabled = 'Not allowed without a structure';
					} else if (slug === 'industrial' && ! data.types.includes('commercial')) {
						disabled = 'Not allowed without the commercial type';
					} else if ([
						'cattle-ranch',
						'dairy-farm',
						'hobby-farm',
						'orchard',
						'organic-farm',
						'row-crop'
					].includes(slug) && ! data.types.includes('agricultural')) {
						disabled = 'Not allowed without the agricultural type';
					} else if ([
						'camping',
						'hunting',
						'waterfowl'
					].includes(slug) && ! data.types.includes('recreational')) {
						disabled = 'Not allowed without the recreational type';
					} else if (slug === 'investment' && data.format === 'lease') {
						disabled = 'Not allowed on leases';
					} else if (slug === 'rent-to-own' && data.format === 'auction') {
						disabled = 'Not allowed on auctions';
					} else if (slug === 'vacant' && data.structure) {
						disabled = 'Not allowed with a structure';
					} else if (slug === 'unrestricted' && data.hoa) {
						disabled = 'Not allowed with an HOA';
					} else if (slug === 'historic') {
						if (! data.built_year) {
							disabled = 'Not allowed without a year built';
						} else if (data.built_year > 1960) {
							disabled = 'Not allowed based on year built';
						}
					} else if (slug === 'new-construction') {
						if (! data.built_year) {
							disabled = 'Not allowed without a year built';
						} else if (data.built_year < new Date().getFullYear() - 2) {
							disabled = 'Not allowed based on year built';
						}
					} else if (slug === 'mixed-use' && ! (
						data.types.includes('commercial') &&
						data.types.includes('residential')
					)) {
						disabled = 'Not allowed without commercial and residential types';
					} else if (data.size) {
						if (slug === 'cattle-ranch' && data.size < 20) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'ranch' && data.size < 5) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'timberland' && data.size < 5) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'chicken-farm' && data.size < 2) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'hobby-farm' && data.size < 2) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'equestrian' && data.size < 1) {
							disabled = 'Not allowed on properties this size';
						} else if (slug === 'hobby-farm' && data.size > 60) {
							disabled = 'Not allowed on properties this size';
						}
					}
				}

				tags[slug] = {
					title: options[slug],
					disabled: disabled
				};
			}

			criteria[key] = {
				definitions: $.view.render('account-post.definitions._' + LS.util.slugify(key)),
				tags: tags
			};
		}

		if (data.fsbo && ! $.app.post.$has(key, 'by-owner')) {
			$.app.post.$push(key, 'by-owner');
		}

		if (! data.structure && ! $.app.post.$has(key, 'vacant')) {
			$.app.post.$push(key, 'vacant');
		}

		if (data.hoa) {
			if (! $.app.post.$has('data.types', 'residential')) {
				$.app.post.$push('data.types', 'residential');
			}

			if (data.bedrooms && ! $.app.post.$has(key, 'house')) {
				$.app.post.$push(key, 'house');
			}
		}

		$.app.post.$set('criteria', criteria);
	},

	/**
	 * Validate criteria step
	 *
	 * @returns {Boolean}
	 */
	criteriaValidate() {
		return true;
	}
});